import React, { useState, useEffect } from "react";
import LogoWhite from "../../assets/img/logo-white.svg";
import DashboardWhite from "../../assets/img/dashboard-white.svg";
import DashboardBlue from "../../assets/img/dashboard-blue.svg";
import WorkWhite from "../../assets/img/work-white.svg";
import WorkBlue from "../../assets/img/work-blue.svg";
import PeopleWhite from "../../assets/img/people-white.svg";
import PeopleBlue from "../../assets/img/people-blue.svg";
import InventoryWhite from "../../assets/img/inventory-white.svg";
import InventoryBlue from "../../assets/img/inventory-blue.svg";
import ChatBlue from "../../assets/img/chat-blue.svg";
import ChatWhite from "../../assets/img/chat-white.svg";
import DomainBlue from "../../assets/img/domain-blue.svg";
import DomainWhite from "../../assets/img/domain-white.svg";
import PreferenceWhite from "../../assets/img/preferenceWhite.svg";
import PreferenceBlue from "../../assets/img/preferenceBlue.svg";
import CalendarBlue from "../../assets/img/calendar.svg";
import CalendarWhite from "../../assets/img/calendar-white.svg";
import VariationWhite from "../../assets/img/variation-white.svg";
import SignalBarBlue from "../../assets/img/signal-bar-blue.svg";
import SignalBarWhite from "../../assets/img/signal-bar-white.svg";
import VariationBlue from "../../assets/img/variation-blue.svg";
import CategoryWhite from "../../assets/img/categoryWhite.svg";
import CategoryBlue from "../../assets/img/categoryBlue.svg";
import CollaboratorsWhite from "../../assets/img/collaboratorsWhite.svg";
import CollaboratorsBlue from "../../assets/img/collaboratorsBlue.svg";
import Logout from "../../assets/img/logout-white.svg";
import { decodeToken } from "../../config/auth";
import { useAuth } from "../../context/ContextApi";

export default function Sidebar(props) {
  const { userId, isPetEstablishment, isFashionEstablishment, isBeautyEstablishment } = useAuth();
  const [user, setUser] = useState({});
  const sidebarProductsServicesLink = isBeautyEstablishment
    ? "Serviços"
    : isPetEstablishment
    ? "Serviços e produtos"
    : "Produtos";
  useEffect(() => {
    if (userId) {
      const { user: session = {} } = decodeToken();
      setUser(session);
    }
  }, []);

  return (
    <>
      <nav id="sidebar" aria-expanded={props.show} className={`d-flex flex-column bg-cl-azure`}>
        <div className="sidebar-scroll ">
          <div className="d-flex justify-content-center">
            <img className="logo w-100 px-3 px-lg-0" alt="" src={LogoWhite} />
          </div>
          <div className="list-items">
            {user?.role === "admin" ? (
              <>
                <SidebarNavLink
                  isActive={props.defaultMenu === 0}
                  link={"/dashboard"}
                  text="Dashboard"
                  iconWhite={DashboardWhite}
                  iconBlue={DashboardBlue}
                />
                <SidebarNavLink
                  isActive={props.defaultMenu === 1}
                  link={"/estabelecimentos"}
                  text="Estabelecimentos"
                  iconWhite={WorkWhite}
                  iconBlue={WorkBlue}
                />
                <SidebarNavLink
                  isActive={props.defaultMenu === 2}
                  link={"/time"}
                  text="Time"
                  iconWhite={PeopleWhite}
                  iconBlue={PeopleBlue}
                />
                <SidebarNavLink
                  isActive={props.defaultMenu === 3}
                  link={"/produtos"}
                  text="Produtos"
                  iconWhite={InventoryWhite}
                  iconBlue={InventoryBlue}
                />
                <SidebarNavLink
                  isActive={props.defaultMenu === 4}
                  link={"/clientes"}
                  text="Clientes"
                  iconWhite={SignalBarWhite}
                  iconBlue={SignalBarBlue}
                />
                <SidebarNavLink
                  isActive={props.defaultMenu === 5}
                  link={"/preferencias"}
                  text="Preferencias"
                  iconWhite={PreferenceWhite}
                  iconBlue={PreferenceBlue}
                />
              </>
            ) : (
              <>
                <SidebarNavLink
                  isActive={props.defaultMenu === 0}
                  link={"/dashboard-user"}
                  text="Dashboard"
                  iconWhite={DashboardWhite}
                  iconBlue={DashboardBlue}
                />
                <SidebarNavLink
                  isActive={props.defaultMenu === 1}
                  link={"/reservas/todas"}
                  text="Reservas"
                  iconWhite={CalendarWhite}
                  iconBlue={CalendarBlue}
                />
                <SidebarNavLink
                  isActive={props.defaultMenu === 2}
                  link={"/produtos"}
                  text={sidebarProductsServicesLink}
                  iconWhite={InventoryWhite}
                  iconBlue={InventoryBlue}
                />
                <SidebarNavLink
                  isActive={props.defaultMenu === 6}
                  link={"/categories-user"}
                  text="Categorias"
                  iconWhite={CategoryWhite}
                  iconBlue={CategoryBlue}
                />
                {isBeautyEstablishment && (
                  <SidebarNavLink
                    isActive={props.defaultMenu === 7}
                    link={"/colaboradores"}
                    text="Colaboradores"
                    iconWhite={CollaboratorsWhite}
                    iconBlue={CollaboratorsBlue}
                  />
                )}
                {isFashionEstablishment ? (
                  <SidebarNavLink
                    isActive={props.defaultMenu === 5}
                    link={"/variacao-produto"}
                    text="Variações de produto"
                    iconWhite={VariationWhite}
                    iconBlue={VariationBlue}
                  />
                ) : (
                  ""
                )}
                <SidebarNavLink
                  isActive={props.defaultMenu === 3}
                  link={"/dados-da-loja"}
                  text="Dados da loja"
                  iconWhite={DomainWhite}
                  iconBlue={DomainBlue}
                />
                <SidebarNavLink
                  isActive={props.defaultMenu === 4}
                  link={"/chat/ver"}
                  text="Chat"
                  iconWhite={ChatWhite}
                  iconBlue={ChatBlue}
                />
              </>
            )}
          </div>
          <SidebarNavLogout text="Logout" iconWhite={Logout} />
        </div>
      </nav>
    </>
  );
}

function SidebarNavLink(props) {
  return (
    <a className="t-decoration-none d-flex align-items-center " href={props.link}>
      <div className={`w-100 item ${props.isActive ? "active" : ""}`}>
        <img alt="" src={props.isActive ? props.iconBlue : props.iconWhite} />
        <span className="description fz-14 ff-univanova-medium ms-1">{props.text}</span>
      </div>
    </a>
  );
}

function SidebarNavLogout(props) {
  return (
    <>
      <div className="d-flex align-items-end list-items mt-auto">
        <div className={`item m-0 w-100`}>
          <button
            data-bs-toggle="modal"
            data-bs-target={"#myModalAlertLogOut"}
            type="button"
            style={{ backgroundColor: "inherit", paddingLeft: "0px" }}
            className="btn t-decoration-none d-flex align-items-center"
            onClick={props.onClick}
          >
            <img alt="" src={props.iconWhite} />
            <span className="description fz-14 ff-univanova-medium">{props.text}</span>
          </button>
        </div>
      </div>
    </>
  );
}
